/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
import { lazy } from "react";

export default {
	'confluence-commented-on-page-nudge': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--confluence-commented-on-page-nudge/placements/in-app/screen-space-flags/render'
			),
	),
	'confluence-continue-reading-nudge': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--confluence-continue-reading-nudge/placements/in-app/screen-space-flags/render'
			),
	),
	'confluence-inline-reactions-nudge': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--confluence-inline-reactions-nudge/placements/in-app/screen-space-flags/render'
			),
	),
	'confluence-mentioned-in-comment-nudge': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--confluence-mentioned-in-comment-nudge/placements/in-app/screen-space-flags/render'
			),
	),
	'confluence-mentioned-on-page-nudge': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--confluence-mentioned-on-page-nudge/placements/in-app/screen-space-flags/render'
			),
	),
	'confluence-nudge-for-jira': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--confluence-nudge-for-jira/placements/in-app/screen-space-flags/render'
			),
	),
	'rovo-3rd-party-integration-admin-nudge': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--rovo-3rd-party-integration-admin-nudge/placements/in-app/screen-space-flags/render'
			),
	),
};
